import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../redux/hooks';
import Loading from '../ui/Loading';
import { Permission } from '../../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermissions?: string[];
  requiredRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermissions = [],
  requiredRoles = [],
}) => {
  const { isLoggedIn, user, isLoading } = useAppSelector(state => state.user);
  const location = useLocation();

  if (isLoading) {
    return (
      <div className='min-h-screen bg-gray-50 flex items-center justify-center'>
        <Loading size='lg' text='Verificando acceso...' />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  if (user) {
    // Check role requirements
    if (requiredRoles.length > 0 && !requiredRoles.includes(user.role)) {
      return (
        <div className='min-h-screen bg-gray-50 flex items-center justify-center'>
          <div className='text-center'>
            <h1 className='text-2xl font-bold text-gray-900 mb-4'>Acceso Denegado</h1>
            <p className='text-gray-600 mb-4'>
              No tienes los permisos necesarios para acceder a esta página.
            </p>
            <button onClick={() => window.history.back()} className='btn-primary'>
              Volver
            </button>
          </div>
        </div>
      );
    }

    // Check permission requirements
    if (requiredPermissions.length > 0) {
      const hasPermission = requiredPermissions.some(permission =>
        user.permissions.includes(permission as Permission)
      );

      if (!hasPermission) {
        return (
          <div className='min-h-screen bg-gray-50 flex items-center justify-center'>
            <div className='text-center'>
              <h1 className='text-2xl font-bold text-gray-900 mb-4'>Acceso Denegado</h1>
              <p className='text-gray-600 mb-4'>
                No tienes los permisos necesarios para acceder a esta página.
              </p>
              <button onClick={() => window.history.back()} className='btn-primary'>
                Volver
              </button>
            </div>
          </div>
        );
      }
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
